// Module dependencies
import ExperimentsClient from 'app/common/lib/ExperimentsClient';
import Pc from 'app/common/lib/Pc';

const experiments = {};
experiments.getInstance = function() {
  const expData = Pc.experiments;
  return new ExperimentsClient(expData.active, expData.triggerable);
};

export default experiments;
